import React, { useState, useRef, useEffect } from "react";
import CompleteMessage from "./CompleteMessage";
import { useUser } from "../../../utils/auth/UserContext";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Tooltip } from "@mui/material";
import "./UserMessage.css";

const UserMessage = ({ content, onEdit }) => {
  const { profileImage } = useUser();
  const [copied, setCopied] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isEditing && textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [isEditing]);

  const handleCopy = () => {
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleEditStart = () => {
    setEditText(content);
    setIsEditing(true);
  };

  const handleEditSubmit = () => {
    if (editText.trim() && editText.trim() !== content && onEdit) {
      onEdit(editText.trim());
    }
    setIsEditing(false);
  };

  const handleEditCancel = () => {
    setIsEditing(false);
    setEditText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleEditSubmit();
    }
    if (e.key === "Escape") {
      handleEditCancel();
    }
  };

  const icon = (
    <div className="icon-div">
      {profileImage ? (
        <img src={profileImage} alt="User Profile" className="user-profile-image" />
      ) : (
        <i className="pi pi-user user-icon" style={{ fontSize: "1.5rem" }}></i>
      )}
    </div>
  );

  const messageContent = (
    <div className="user-message-wrapper">
      {isEditing ? (
        <div className="user-edit-container">
          <textarea
            ref={textareaRef}
            value={editText}
            onChange={(e) => {
              setEditText(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = e.target.scrollHeight + "px";
            }}
            onKeyDown={handleKeyDown}
            className="user-edit-textarea"
            rows={1}
          />
          <div className="user-edit-actions">
            <Tooltip title="Submit (Enter)" arrow>
              <IconButton size="small" onClick={handleEditSubmit} className="edit-submit-btn">
                <CheckIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Cancel (Esc)" arrow>
              <IconButton size="small" onClick={handleEditCancel} className="edit-cancel-btn">
                <CloseIcon style={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      ) : (
        <>
          <div
            className="message user"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <div className="user-message-actions">
            <Tooltip title={copied ? "Copied!" : "Copy"} arrow>
              <IconButton size="small" onClick={handleCopy} className="user-action-btn">
                {copied ? (
                  <CheckIcon style={{ fontSize: 14 }} />
                ) : (
                  <ContentCopyIcon style={{ fontSize: 14 }} />
                )}
              </IconButton>
            </Tooltip>
            {onEdit && (
              <Tooltip title="Edit & resend" arrow>
                <IconButton size="small" onClick={handleEditStart} className="user-action-btn">
                  <EditIcon style={{ fontSize: 14 }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </>
      )}
    </div>
  );

  return <CompleteMessage type="user" icon={icon} message={messageContent} content={content} />;
};

export default UserMessage;
